export type SalesForceTracking = {
  campaignId: string;
  templateId: string;
};

export type WithSalesforceTracking = Partial<SalesForceTracking>;

export const SALESFORCE_TRACKING_KEYS = ['campaignId', 'templateId'];
